import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react'
import withRouter from '../../../components/Common/withRouter'
import { withTranslation } from 'react-i18next'
import {
 getPayments as onGetPayments,
 confirmPayment as onConfirmPayment,
 getAllBankAccounts as onGetAllBankAccounts,
} from '../../../slice/thunks'
import { useSelector, useDispatch } from "react-redux"
import moment from 'moment'
import makeAnimated from "react-select/animated"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { createSelector } from "reselect"
import Select from "react-select"
import { Col, Input, Label, Row } from 'reactstrap'
import { Link } from 'react-router-dom'
import GlobalLoader from '../../../components/Common/GlobalLoader'
import ConfirmModal from '../../../components/Global/ConfirmModal'
import TableContainer from '../../../components/Common/TableContainer'


function SalePatientPayment(props) {
  const dispatch = useDispatch() 
  const animatedComponents = makeAnimated()
  const selectLayoutState = (state) => state.Settings;
  const SettingsProperties = createSelector(
      selectLayoutState,
      (setting) =>({
        payments: setting.payments,
        payment: setting.payment,
        allBankingAccounts: setting.allBankingAccounts,
        confirmPaymentSuccess: setting.confirmPaymentSuccess,
        error: setting.error,
      })
  )
  const { payments, payment, confirmPaymentSuccess, allBankingAccounts, error } = useSelector(SettingsProperties)
  const [isLoading, setIsLoading] = useState(true)
  const [confirmModal, setConfirmModal] = useState(false)
  const [ currentPayment, setCurrentPayment] = useState(null)
  const [searchInput, setSearchInput] = useState('')
  const [ paymentOption, setPaymentOption ] = useState(null)
  const [ selectedPaymentM, setSelectedPaymentM ] = useState(null)
  const [ selectedUser, setSelectedUser ] = useState(null)
  const [periods, setPeriods] = useState([]);
  const [filterPayment, setFilterPayment] = useState(null)
  const [selectedConfirm, setSelectedConfirm] = useState(null)
  const confirmOption = [
    {label: props.t("all"), value: "All"},
    {label: props.t("yes"), value: "Yes"},
    {label: props.t("no"), value: "No"},
  ]
  const fp = useRef(null);



  const loadPayments = useCallback((pageNumber, pageSize) => {
    let reqObject = {}
    if ((pageNumber !== null) && (pageNumber != undefined)) reqObject.pageNumber = pageNumber;
    if ((pageSize !== null) && (pageSize != undefined)) reqObject.pageSize = pageSize;
    if (filterPayment !== null) reqObject.methods = filterPayment;
    if (selectedUser !== null) reqObject.users = selectedUser;
    if (selectedConfirm !== null) reqObject.confirm = selectedConfirm.value;
    if (periods.length > 0) reqObject.startDate = moment(periods[0]).format("YYYY-MM-DD");
    if (periods.length > 0) reqObject.endDate = moment(periods[1]).format("YYYY-MM-DD");
    if (searchInput !== null) reqObject.term = searchInput;

    dispatch(onGetPayments(reqObject))
  })

  const loadPaymentMode = useCallback(() => {
      dispatch(onGetAllBankAccounts(true))
  })

  useEffect(() =>{
    if (props.isActive) {
      loadPayments()
      loadPaymentMode()
    }
  },[props.isActive])

  useEffect(() => {
    if (payments && payments.page > 0) {
      setIsLoading(false)
    }
  },[payments])

  useEffect(() => {
    if (confirmPaymentSuccess && !error) {
      loadPayments()
      setConfirmModal(false)
      setCurrentPayment(null)
    }
  },[confirmPaymentSuccess, payment])

  useEffect(() => {
    if (allBankingAccounts && allBankingAccounts.length > 0) {
        const payment_lists = allBankingAccounts.filter(mode => mode.value !== 'PATIENT_CREDIT').map(mode => ({
          label: mode.bankName,
          value: mode.id
        }));
        setPaymentOption(payment_lists);
    }
  }, [allBankingAccounts]);


  useEffect(() => {
    if (selectedPaymentM && selectedPaymentM.length > 0) {
      let filter_payment = null
      selectedPaymentM.forEach(row => {
        filter_payment = filter_payment === null ? row.value : filter_payment+","+row.value
      });
      setFilterPayment(filter_payment)
    }
  },[selectedPaymentM])

  useEffect(() => {
    if (selectedConfirm || selectedPaymentM || selectedUser ||  periods.length > 0 || filterPayment) {
        loadPayments()
      }
  },[selectedConfirm, selectedPaymentM, selectedUser, periods, filterPayment])

  const onClickConfirm = (row) => {
    setCurrentPayment(row);
    setConfirmModal(true);
  }

  const handleConfirmPayment = () => {
    if (currentPayment) {
      dispatch(onConfirmPayment( currentPayment.id ))
    }
  }

  function handleSearch () {
    loadPayments()
  }

  function capitalizeName(name) {
    if (!name) return '';
    return name
        .split(' ') 
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
        .join(' '); 
  }

  const ObjectFilter = [
    {
      id: "date-range",
      label: props.t("select_date_range"),
      component: (
        <Flatpickr
          className='flatpick-custom'
          ref={fp}
          placeholder={props.t("select_date_range")}
          defaultValue={periods}
          value={periods}
          options={{
            altInput: true,
            altFormat: "d / m/ Y",
            maxDate: new Date(),
            mode: "range",
          }}
          onChange={e => e.length > 1 && setPeriods(e)}
        />
      ),
    },
    {
      id: "done-by",
      label: props.t("done_by"),
      component: (
        <Input
          className="custom-border form-control"
          value={selectedUser}
          onChange={e => setSelectedUser(e.target.value)}
        />
      ),
    },
    {
      id: "payment-mode",
      label: props.t("bank_acc"),
      component: (
        <Select
          value={selectedPaymentM}
          isMulti
          isClearable={false}
          onChange={setSelectedPaymentM}
          options={paymentOption}
          closeMenuOnSelect={false}
          components={animatedComponents}
        />
      ),
    },
    {
      id: "confirm-question",
      label: props.t("confirm_question"),
      component: (
        <Select
          value={selectedConfirm}
          isMulti={false}
          isClearable={false}
          onChange={setSelectedConfirm}
          options={confirmOption}
          closeMenuOnSelect
          components={animatedComponents}
        />
      ),
    },
    {
      id: "search",
      label: props.t("search"),
      component: (
        <div className="d-flex align-items-center">
          <Input
            className="custom-border form-control me-2"
            value={searchInput}
            onChange={e => setSearchInput(e.target.value)}
          />
          <button type="button" onClick={handleSearch} className="btn btn-primary">
            <i className="fa fa-search p-0"></i>
          </button>
          <button
            type="button"
            className="btn btn-warning mx-1"
            onClick={() => {
              if (!fp?.current?.flatpickr) return;
              fp.current.flatpickr.clear();
              setPeriods([]);
              setSearchInput('');
              setFilterPayment(null);
              setSelectedConfirm(null);
              setSelectedUser('');
              setSelectedPaymentM([]);
              dispatch(onGetPayments());
            }}
          >
            {props.t("clear")}
          </button>
        </div>
      ),
    },
  ];

  const columns = useMemo(
    () => [
      {
        header: props.t("patient_name"),
        style: "type",
        enableColumnFilter: false,
        cell: (cell) => {
          return <span>{capitalizeName(cell.row.original.invoice.saleOrder.patient.firstName+" "+cell.row.original.invoice.saleOrder.patient.lastName)}</span>
        }
      },
      {
        header: props.t("payment_ref"),
        style: "type",
        enableColumnFilter: false,
        cell: (cell) => {
          return <span>{cell.row.original.paymentRef}</span>
        }
      },
      {
        header: props.t("amount"),
        style: "type",
        enableColumnFilter: false,
        cell: (cell) => {
          return <span>{cell.row.original.amountPaid}</span>
        }
      },
      {
        header: props.t("invoice_ref"),
        style: "type",
        enableColumnFilter: false,
        cell: (cell) => {
          return <span>{cell.row.original.invoice.invoiceRef}</span>
        }
      },
      {
        header: props.t("payment_mode"),
        style: "type",
        enableColumnFilter: false,
        cell: (cell) => {
          return <span>{cell.row.original.paymentMode}</span>
        }
      },
      {
        header: props.t("date_heure"),
        style: "cat",
        enableColumnFilter: false,
        cell: (cell) => {
          return <span>
              {moment(cell.row.original.paymentDate).format('DD / MM/ YYYY HH:mm')}
          </span>;
        },
      },
      {
        header: props.t("action"),
        style: "action",
        cell: (cellProps) => {
          return (
            <div className="d-flex justify-content-start">
                <ul className="list-inline hstack mb-0">
                  {cellProps.row.original.confirmedBy === '' ?
                    <li className="list-inline-item edit" title={props.t("confirm_payment")}>
                      <Link
                        to="#"
                        className="text-dark d-inline-block edit-item-btn" style={{fontSize: "15px" }}
                        onClick={() => onClickConfirm(cellProps.row.original)}
                      >
                        <i className="fa fa-check" aria-hidden="true"></i>
                      </Link>
                    </li>
                    :
                    <></>
                  }
                </ul>
            </div>
          );
        },
      },
    ],
    [payments, onClickConfirm]
  );

  return (
    <React.Fragment>
      {isLoading ?
        <GlobalLoader />
        :
        <>
          <ConfirmModal show={confirmModal} onConfirmClick={handleConfirmPayment} onCloseClick={() =>setConfirmModal(false)} />

          <div className="patients-list-content">
            <div className="patients-list px-2 pb-5 ">
              <div className="container-fluid ">

                <div className="card border-0 row p-4 mt-2">
                  <Row>
                    {ObjectFilter.map(({ id, label, component }, index) => (
                      <Col key={id} xl={id === "search" ? 3 : 2} sm={4}>
                        <div className='mb-2'>
                          <Label className="form-label" htmlFor={id}>{label}</Label>
                          {component}
                        </div>
                      </Col>
                    ))}
                  </Row>

                  <div className="row">
                    <TableContainer
                      columns={columns}
                      data={((payments && payments.items) || [])}
                      isGlobalFilter={false}
                      customPageSize={10}
                      divClass="card table-card table-warehouse table-responsive"
                      tableClass="table"
                      theadClass="thead-sec table-light"
                      tdClass="td"
                      tableSize={ payments && payments.size }
                      tablePage={ payments && payments.page }
                      tableTotal= { payments && payments.total_items }
                      tableTotalPage= { payments && payments.total_page }
                      onNextPage= {loadPayments}
                      onSearch= {loadPayments}
                      SearchPlaceholder={props.t("search_payment")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(SalePatientPayment))
